import types from '../actions/types';
import {paginatedResultReducer, initialState} from './common/paginated_results';
import {singleResultReducer, singleResultInitialState} from './common/single-result';

const initial_state = {
    post: singleResultInitialState,
    posts: initialState
}

export default function(state = initial_state, action) {
    switch (action.type) {
        case types.DELETE_POST.SUCCESS:

            return {
                ...state,
                posts: {
                    ...state.posts,
                    items: removePost(state.posts.items, action.payload.id)
                }

            }

        default:
            return {
                ...state,
                posts: paginatedResultReducer(state.posts, types.LOAD_POSTS_PAGINATED, action),
                post: singleResultReducer(state.post, types.LOAD_POST, action)

            };
    }
}
function removePost(posts, postToRemoveId) {
    let postsReturn = [];
    posts.forEach(post => {
        if (post.id !== postToRemoveId) {
            postsReturn.push(post);
        }
    });
    return postsReturn;
}



// WEBPACK FOOTER //
// ./src/js/reducers/post.js